import { openAiCostLimitEdition } from '@UI/Pages/Administration/Shared/Signals/aiCostLimitSidebarSignal';
import { setAiCostLimitToDelete } from '@UI/Pages/Administration/AiCostLimits/Signals/aiCostLimitToDeleteSignal';
import { css } from '@emotion/react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

const actionsRowStyle = css`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.5rem;
`;

type Props = {
	readonly limitId: number;
	readonly subjectName: string;
};

/** Leaf actions: they open their overlays through the signals' setters, with no callback props. */
const LimitRowActions: React.FC<Props> = ({ limitId, subjectName }) => {
	const handleEditClick = React.useCallback(() => {
		openAiCostLimitEdition(limitId);
	}, [limitId]);

	const handleDeleteClick = React.useCallback(() => {
		setAiCostLimitToDelete(limitId);
	}, [limitId]);

	return (
		<div css={actionsRowStyle}>
			<Button
				type="button"
				size="sm"
				severity="secondary"
				aria-label={`Modifier le plafond de ${subjectName}`}
				onClick={handleEditClick}
			>
				Modifier
			</Button>
			<Button
				type="button"
				size="sm"
				severity="danger"
				aria-label={`Supprimer le plafond de ${subjectName}`}
				onClick={handleDeleteClick}
			>
				Supprimer
			</Button>
		</div>
	);
};

export default LimitRowActions;
